// Shell icons: 16 px, 1.6 px stroke, currentColor. Kept local so the
// shell does not depend on the mixed-weight legacy icon set.
import React from "react";
import AIIcon from "../icons/AIIcon";

const Icon = ({ children, size = 16, className = "", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
    {...props}
  >
    {children}
  </svg>
);

const make = (paths) => {
  const Component = (props) => <Icon {...props}>{paths}</Icon>;
  return Component;
};

export const HomeIcon = make(
  <>
    <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1z" />
  </>,
);
export const PhoneIcon = make(
  <path d="M5 4h3.2l1.6 4.2-2 1.3a11 11 0 0 0 6.7 6.7l1.3-2L20 15.8V19a1.5 1.5 0 0 1-1.6 1.5A16 16 0 0 1 3.5 5.6 1.5 1.5 0 0 1 5 4z" />,
);
export const PhoneOffIcon = make(
  <>
    <path d="M10.7 13.3a11 11 0 0 0 3.5 2.2l1.3-2L20 15.8V19a1.5 1.5 0 0 1-1.6 1.5 16 16 0 0 1-8.9-3.7" />
    <path d="M6.4 14.4A16 16 0 0 1 3.5 5.6 1.5 1.5 0 0 1 5 4h3.2l1.6 4.2-2 1.3" />
    <path d="M3 21 21 3" />
  </>,
);
export const CampaignIcon = make(
  <>
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="0.6" fill="currentColor" />
  </>,
);
export const ContactsIcon = make(
  <>
    <circle cx="9" cy="8.5" r="3.5" />
    <path d="M3 20c.6-3.4 3-5.5 6-5.5s5.4 2.1 6 5.5" />
    <path d="M16 5.2a3.5 3.5 0 0 1 0 6.6M18 14.8c1.6.8 2.7 2.6 3 5.2" />
  </>,
);
export const BuildingIcon = make(
  <>
    <path d="M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16" />
    <path d="M15 9h4a1 1 0 0 1 1 1v11M3 21h18" />
    <path d="M8 8h3M8 12h3M8 16h3" />
  </>,
);
export const ListIcon = make(
  <>
    <path d="M9 6h11M9 12h11M9 18h11" />
    <circle cx="4.5" cy="6" r="0.8" fill="currentColor" />
    <circle cx="4.5" cy="12" r="0.8" fill="currentColor" />
    <circle cx="4.5" cy="18" r="0.8" fill="currentColor" />
  </>,
);
export const DealIcon = make(
  <>
    <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9z" />
    <circle cx="8" cy="8" r="1.4" />
  </>,
);
export const PipelineIcon = make(
  <>
    <rect x="3" y="4" width="5" height="16" rx="1" />
    <rect x="10" y="4" width="5" height="11" rx="1" />
    <rect x="17" y="4" width="4" height="7" rx="1" />
  </>,
);
export const ReportsIcon = make(
  <>
    <path d="M4 20h16" />
    <path d="M7 16v-5M12 16V6M17 16v-8" />
  </>,
);
export const TeamIcon = make(
  <>
    <circle cx="12" cy="8" r="3.2" />
    <path d="M6 20c.5-3.2 3-5.2 6-5.2s5.5 2 6 5.2" />
    <circle cx="4.8" cy="10.5" r="2" />
    <circle cx="19.2" cy="10.5" r="2" />
  </>,
);
export const SettingsIcon = make(
  <>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </>,
);
export const ShieldIcon = make(
  <path d="M12 3 5 6v5.5c0 4.4 3 8.2 7 9.5 4-1.3 7-5.1 7-9.5V6z" />,
);
export const AssistantIcon = make(
  <>
    <path d="M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-8l-4 4v-4H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" />
    <path d="M8.5 10.5h7" />
  </>,
);
export const SearchIcon = make(
  <>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m20 20-4.2-4.2" />
  </>,
);
export const ChevronDownIcon = make(<path d="m6 9 6 6 6-6" />);
export const ChevronRightIcon = make(<path d="m9 6 6 6-6 6" />);
export const SidebarIcon = make(
  <>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M9 4v16" />
  </>,
);
export const MenuIcon = make(<path d="M4 7h16M4 12h16M4 17h16" />);
export const SunIcon = make(
  <>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />
  </>,
);
export const MoonIcon = make(<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />);
export const LogoutIcon = make(
  <>
    <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
    <path d="M10 16l-4-4 4-4M6 12h10" />
  </>,
);
export const UserIcon = make(
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20.5c.8-4 3.8-6 7.5-6s6.7 2 7.5 6" />
  </>,
);
export const MicIcon = make(
  <>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" />
  </>,
);
export const MicOffIcon = make(
  <>
    <path d="M15 10V6a3 3 0 0 0-5.7-1.3M9 9v2a3 3 0 0 0 4.6 2.5" />
    <path d="M18.5 11a6.5 6.5 0 0 1-1 3.4M5.5 11a6.5 6.5 0 0 0 9.8 5.6M12 17.5V21M3 3l18 18" />
  </>,
);
export const PauseIcon = make(<path d="M9 5v14M15 5v14" />);
export const PlayIcon = make(<path d="M7 4.5v15l12-7.5z" />);
export const RefreshIcon = make(
  <>
    <path d="M20 11a8 8 0 0 0-14.3-4.9L4 8" />
    <path d="M4 4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16" />
    <path d="M20 20v-4h-4" />
  </>,
);
export const HistoryIcon = make(
  <>
    <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
    <path d="M3.5 4.5v4h4" />
    <path d="M12 8v4.2l2.8 1.8" />
  </>,
);
export const XIcon = make(<path d="M6 6l12 12M18 6 6 18" />);
export const ArrowRightIcon = make(<path d="M5 12h14M13 6l6 6-6 6" />);
export const CheckIcon = make(<path d="m5 12.5 4.5 4.5L19 7.5" />);
export const DotIcon = make(<circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />);
/** Call history: a handset beside list lines. */
export const CallsIcon = make(
  <>
    <path d="M4.5 4h2.6l1.3 3.4-1.6 1a9 9 0 0 0 4.8 4.8l1-1.6 3.4 1.3V15.5a1.2 1.2 0 0 1-1.3 1.2A13 13 0 0 1 3.3 5.3 1.2 1.2 0 0 1 4.5 4z" />
    <path d="M15 5h5M15 8.5h5M17 12h3" />
  </>,
);
/** The live floor: concentric rings around a node. */
export const FloorIcon = make(
  <>
    <circle cx="12" cy="12" r="2" />
    <path d="M7.8 7.8a6 6 0 0 0 0 8.4M16.2 7.8a6 6 0 0 1 0 8.4" />
    <path d="M4.9 4.9a10 10 0 0 0 0 14.2M19.1 4.9a10 10 0 0 1 0 14.2" />
  </>,
);
/** Coach, as a neutral nav glyph (amber stays for the coach's own voice). */
export const CoachIcon = make(
  <>
    <path d="M12 3.5a6.5 6.5 0 0 0-3.8 11.8V18h7.6v-2.7A6.5 6.5 0 0 0 12 3.5z" />
    <path d="M9.5 21h5" />
  </>,
);
/** Ask Nexus: a four-point spark. */
export const SparkIcon = make(
  <path d="M12 3.5c.5 4.2 2.3 6 6.5 6.5-4.2.5-6 2.3-6.5 6.5-.5-4.2-2.3-6-6.5-6.5 4.2-.5 6-2.3 6.5-6.5zM18.5 15.5c.2 1.6.9 2.3 2.5 2.5-1.6.2-2.3.9-2.5 2.5-.2-1.6-.9-2.3-2.5-2.5 1.6-.2 2.3-.9 2.5-2.5z" />,
);
export const TransferIcon = make(
  <>
    <path d="M4 8h13l-3.5-3.5M20 16H7l3.5 3.5" />
  </>,
);
/** Focus: open the full Live view. */
export const FocusIcon = make(
  <path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" />,
);
export const UnfoldIcon = make(<path d="m8 9 4-4 4 4M8 15l4 4 4-4" />);
export const AlertIcon = make(
  <>
    <path d="M10.3 4.2 2.9 17a2 2 0 0 0 1.7 3h14.8a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9.5v4M12 17h.01" />
  </>,
);
export const KeyboardIcon = make(
  <>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M7 10h.01M11 10h.01M15 10h.01M7 14h10" />
  </>,
);

/** The coach mark: the amber spark. Amber is reserved for the coach. */
export const CoachMark = ({ size = 14, className = "" }) => (
  <span
    aria-hidden="true"
    className={`sg-coach-mark inline-flex flex-none text-sg-coach ${className}`}
    style={{ width: size, height: size }}
  >
    <AIIcon className="h-full w-full" />
  </span>
);

/** Nexus wordmark glyph: two strokes meeting at a node. */
export const NexusGlyph = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M5 19V5l14 14V5"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
